// Shared breadcrumb trail for the Coordination suite.
//
// Usage: <CoordinationBreadcrumbs items={[{ label: "Issues", to: "/issues" }, { label: "New issue" }]} />
// The leading "Coordination" crumb (→ /coordination, the side-menu landing)
// is prepended automatically — pages only pass their own trail. Entries with
// a `to` render as react-router Links; the last / linkless entry renders as
// plain text (the current page). On the landing itself, pass no items (or
// just `current`) and only "Coordination" shows as plain text.
import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";

export default function CoordinationBreadcrumbs({ items, current }) {
  const trail = Array.isArray(items) ? items.filter(Boolean) : [];
  if (current) trail.push({ label: current });

  // Landing crumb: a link whenever there is a trail below it, plain text
  // when it IS the current page.
  const crumbs = [
    trail.length
      ? { label: "Coordination", to: "/coordination" }
      : { label: "Coordination" },
    ...trail,
  ];

  return (
    <Breadcrumb
      style={{ marginBottom: 14 }}
      items={crumbs.map((c, i) => ({
        key: `${c.label}-${i}`,
        title:
          c.to && i < crumbs.length - 1 ? (
            <Link to={c.to}>{c.label}</Link>
          ) : (
            c.label
          ),
      }))}
    />
  );
}
